<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M17 16H19V8C19 6.9 18.1 6 17 6H9V8H17V16ZM7 18V2H5V6H1V8H5V18C5 19.1 5.9 20 7 20H17V24H19V20H23V18H7Z" />
  </svg>
</template>
